export const MEDIA_CREATED = "Media Added to Library";
export const MEDIA_UPDATED = "Media Updated in Library";
export const MEDIA_DELETED = "Media Deleted from Library";
